'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("pillNatureProduit", function (security, urlUtils, $translate, $applications) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      nature: "@"
    },
    template: '<span class="pill-nature-produit icon-nature-{{::nature}}" tl-tooltip>' + '<tl-tooltip-content><div class="tooltip">{{::getTooltip()}}</div></tl-tooltip-content></span>',
    link: function link($scope, $el, $attrs) {
      var unwatch = $scope.$watch("nature", function (nature) {
        if (!nature) {
          return;
        }
        if ($applications.isPretApplication()) {
          if ($scope.nature === 'EMPRUNT_BANCAIRE') {
            $scope.nature = 'PRET';
          }
        }
        var initiales = $translate('nature.initiales.' + $scope.nature);
        if (initiales) {
          $el.text(initiales);
        }

        // obligé de recopier dans une autre variable sinon c'est l valeur initiale qui est conservée
        $scope.natureFinal = $scope.nature;
        $scope.getTooltip = function () {
          return $translate('nature.' + $scope.natureFinal);
        };
        unwatch();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/pills/pillNatureProduit.js
// module id = 2985
// module chunks = 13